export interface IImageModel extends Components.Schemas.ImageDto {}

export enum EFileStatus {
  Error = 'error',
  Success = 'success',
  Done = 'done',
  Uploading = 'uploading',
  Removed = 'removed'
}
